<template>
    <div class="pet-list-item">
        <img class="pet-image" :src="getImageUrl(PetDetails)" :alt="PetDetails.Name">
        <h4>{{PetDetails.Name}}</h4>
    </div>
</template>
<script>
import pawIcon from '../assets/paw_icon.png'
import { mapGetters } from 'vuex'
export default {
    name: "PetListItem",
    props: ['PetDetails'],
    methods: {
        getImageUrl(PetDetails) {
            return pawIcon;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/PetListItem.vue